import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class SaleGoodsIssueDateEarlierThanAdjustedError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.goods-issue-date.earlier-than-adjusted');
    }
}

export class SaleGoodsIssueDateShouldBeEmpty extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.goods-issue-date.should-be-empty');
    }
}

export class SaleGoodsIssueDateShouldNotBeEmpty extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.goods-issue-date.should-not-be-empty');
    }
}
